<div class="form-group no-margin">
  <div class="input-group">
    <div class="input-group-prepend">
      <button [disabled]="dateForm.get('date').disabled || isDateNotSelectable"
        class="btn btn-outline-secondary feather  btn-sm"
        (click)="datePick.open()"
        type="button"
      rippleEffect>
      <mat-icon class="calendar-icon">calendar_today</mat-icon>
      </button>
    </div>
    <input matInput
      class="form-control"
      style="margin-top: unset;"
      placeholder="dd-mm-yyyy"
      [formControl]="dateControl"
      [matDatepicker]="datePick"
      [ngClass]="{'is-invalid': error || ( dateForm.get('date')?.touched && dateForm.get('date')?.errors) || (dateTimeFormControl?.touched && dateTimeFormControl?.errors) , 'pointer': isReadonly || disabled}"
      [max]="max"
      [min]="min"
      (click)="!disabled && !isDateNotSelectable && datePick.open()"
      [readonly]="isReadonly || disabled">
      <mat-datepicker #datePick
      [touchUi]="isMobile"></mat-datepicker>

      @if (!disableClearBtn && dateForm.get('date').enabled) {
        <div class="input-group-append"
          >
          <button type="button"
            (click)="onResetDate()"
            [disabled]="dateForm.get('date').disabled || isDateNotSelectable"
            class="btn btn-icon btn-outline-secondary"
            rippleEffect>
            <span [data-feather]="'x'"></span></button>
          </div>
        }

        @if (customBtn) {
          <div class="input-group-append"
            >
            <button type="button"
              (click)="onCustomBtnClick()"
              [disabled]="dateForm.get('date').disabled || isDateNotSelectable"
              class="btn btn-icon btn-outline-secondary"
              rippleEffect>
              {{btnText | translate}}
            </button>
          </div>
        }
      </div>

      @if (!disableInternalErrorMessage) {
        @if (dateForm.get('date').errors?.required && dateForm.get('date').touched) {
          <small class="text-danger"
            >
            This field is required
          </small>
        }
        @if (dateForm.errors?.dateRange) {
          <small class="text-danger"
            >
            {{dateForm.errors?.dateRange}}
          </small>
        }
        @if (isDateNotSelectable && dateNotSelectableCustomText) {
          <small class="text-danger"
            >{{dateNotSelectableCustomText |
          translate}}</small>
        }
      }

    </div>
